/** The look of a code: everything the renderer needs that is not the data. */

export type ModuleStyle = "square" | "rounded" | "dots" | "fluid" | "classy" | "diamond";
export type EyeStyle = "square" | "rounded" | "circle" | "leaf";
export type LogoShape = "square" | "rounded" | "circle";

export interface Paint {
  kind: "solid" | "linear" | "radial";
  /** Solid colour, or the first stop of a gradient. */
  color: string;
  /** Second stop; ignored when kind is "solid". */
  color2: string;
  /** Gradient direction in degrees, clockwise from "left to right". */
  angle: number;
}

export interface Logo {
  /** A data: URL — never a remote one, so the SVG stays self-contained. */
  href: string;
  /** Width as a fraction of the code's width. */
  scale: number;
  /** Modules of clear space kept around it. */
  padding: number;
  shape: LogoShape;
  /** Draw the background colour behind it, hiding the modules underneath. */
  plate: boolean;
}

export interface QrStyle {
  modules: ModuleStyle;
  eyes: EyeStyle;
  /** Quiet zone in modules. Scanners want at least 4; 2 usually still reads. */
  margin: number;
  fill: Paint;
  /** Colour for the three corner eyes, or null to use the module fill. */
  eyeColor: string | null;
  /** Background colour, or null for transparent. */
  background: string | null;
  logo: Logo | null;
}

export const MODULE_STYLES: { value: ModuleStyle; label: string }[] = [
  { value: "square", label: "Classic" },
  { value: "rounded", label: "Rounded" },
  { value: "dots", label: "Dots" },
  { value: "fluid", label: "Fluid" },
  { value: "classy", label: "Classy" },
  { value: "diamond", label: "Diamond" },
];

export const EYE_STYLES: { value: EyeStyle; label: string }[] = [
  { value: "square", label: "Square" },
  { value: "rounded", label: "Rounded" },
  { value: "circle", label: "Circle" },
  { value: "leaf", label: "Leaf" },
];

export const DEFAULT_STYLE: QrStyle = {
  modules: "square",
  eyes: "square",
  margin: 4,
  fill: { kind: "solid", color: "#1f3f39", color2: "#4f8496", angle: 45 },
  eyeColor: null,
  background: "#ffffff",
  logo: null,
};
